import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackCopiedShareLink } from "@air/analytics";
import { memo } from "react";
import { CopyLinkButton } from "~/components/SharePrivateContentModal/CopyLinkButton";
import { SharePrivateContentLink } from "~/components/SharePrivateContentModal/SharePrivateContentLink";
import { getFullShareUrl } from "~/utils/shareUrl";
export const ReadonlySharePrivateLink = /*#__PURE__*/ memo((param)=>{
    let { objectId, trackLocation, shareId, objectType } = param;
    const { trackCopiedShareLink } = useTrackCopiedShareLink();
    const shareUrl = getFullShareUrl(shareId);
    const onCopied = ()=>{
        trackCopiedShareLink({
            id: objectId,
            shareId,
            type: objectType,
            location: trackLocation
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ _jsx(SharePrivateContentLink, {
                shareUrl: shareUrl
            }),
            /*#__PURE__*/ _jsx(CopyLinkButton, {
                shareUrl: shareUrl,
                onCopied: onCopied
            })
        ]
    });
});
ReadonlySharePrivateLink.displayName = "ReadonlySharePrivateLink";
